<template lang="pug">
  .box.page-home.has-shadow(v-if="visitedLessons.length")
    section.pt-0
      .columns
        .column.is-wide
          h3.title.has-text-left
            | Lessons created for me
        .column.text-align-right.is-narrow
          button#btn_teachee_total.button.is-primary.is-outlined.is-small.mr-2(
            title="Download one Anki deck cumulating all your lessons"
            @click="exportTotal"
            :class="{'is-loading': totalLoading}"
            :disabled="totalLoading")
            b-icon(icon="save" custom-size="mdi-18px")
            span Teachee total
          button#btn_refresh.button.is-outlined.is-small(@click="refresh" v-shortkey="['r']" @shortkey="refresh()")
            b-icon(icon="sync" custom-size="mdi-18px" :custom-class="(isRefreshing) ? 'fa-spin' : ''")
            span
              u
                | R
              | efresh
      .section.pt-0
        lessons-list(:lessons="visitedLessons" group-by="language_to" read-only="true")
</template>


<script>
import { mapGetters } from "vuex";
import LessonsList from "@/components/LessonsListV2";
import throttle from "lodash/throttle";
import AnkiExportPoll from "@/mixins/AnkiExportPoll";

export default {
  name: "VisitedLessons",
  components: {
    lessonsList: LessonsList
  },
  mixins: [AnkiExportPoll],
  data() {
    return {
      isRefreshing: false,
      totalLoading: false,
      user: {
        id: null
      }
    };
  },
  computed: mapGetters(["visitedLessons", "apiUrl"]),
  created() {
    this.$store.dispatch("getVisitedLessons");
  },
  methods: {
    refresh: throttle(function() {
      this.isRefreshing = true
      this.$store.dispatch("getVisitedLessons").then(() => {
        this.isRefreshing = false
      });
    }, 500),
    exportTotal() {
      this.totalLoading = true
      this.$http.post(this.apiUrl + "/anki_totals", {}).then(res => {
        this.pollAnkiExport(res.body.token, "teachee_total", () => {
          this.totalLoading = false
        });
      }).catch(err => {
        this.totalLoading = false
        const msg = (err.body && err.body.message) || "Export failed. Please try again."
        this.$toast.error(msg, { duration: 8000 })
      })
    }
  }
};
</script>


<style lang="scss" scoped>
</style>
